// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IEmployeeContributionLimitResponse,
  IIrsLimitsSearchRequest,
} from '../models/index';
import {
    IEmployeeContributionLimitResponseFromJSON,
    IEmployeeContributionLimitResponseToJSON,
    IIrsLimitsSearchRequestFromJSON,
    IIrsLimitsSearchRequestToJSON,
} from '../models/index';

export interface SearchEmployeesIrsLimitsRequest {
    iIrsLimitsSearchRequest: IIrsLimitsSearchRequest;
}

/**
 * ContributionControllerApi - interface
 * 
 * @export
 * @interface ContributionControllerApiInterface
 */
export interface ContributionControllerApiInterface {
    /**
     * Retrieves IRS contribution limits for specified employee-plan-tax year combinations
     * @summary Search for employees IRS contribution limits
     * @param {IIrsLimitsSearchRequest} iIrsLimitsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContributionControllerApiInterface
     */
    searchEmployeesIrsLimitsRaw(requestParameters: SearchEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeContributionLimitResponse>>>;

    /**
     * Retrieves IRS contribution limits for specified employee-plan-tax year combinations
     * Search for employees IRS contribution limits
     */
    searchEmployeesIrsLimits(requestParameters: SearchEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeContributionLimitResponse>>;

}

/**
 * 
 */
export class ContributionControllerApi extends runtime.BaseAPI implements ContributionControllerApiInterface {

    /**
     * Retrieves IRS contribution limits for specified employee-plan-tax year combinations
     * Search for employees IRS contribution limits
     */
    async searchEmployeesIrsLimitsRaw(requestParameters: SearchEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IEmployeeContributionLimitResponse>>> {
        if (requestParameters['iIrsLimitsSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'iIrsLimitsSearchRequest',
                'Required parameter "iIrsLimitsSearchRequest" was null or undefined when calling searchEmployeesIrsLimits().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/contribution-requests/irs-limits/search`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IIrsLimitsSearchRequestToJSON(requestParameters['iIrsLimitsSearchRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IEmployeeContributionLimitResponseFromJSON));
    }

    /**
     * Retrieves IRS contribution limits for specified employee-plan-tax year combinations
     * Search for employees IRS contribution limits
     */
    async searchEmployeesIrsLimits(requestParameters: SearchEmployeesIrsLimitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IEmployeeContributionLimitResponse>> {
        const response = await this.searchEmployeesIrsLimitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
